import PropTypes from 'prop-types';

import { GlJournalPropTypes, GlJournalsPropTypes } from '../../shared/propTypes/glJournals';

export {
  GlJournalPropTypes,
  GlJournalsPropTypes,
};

export const GlAccountPropTypes = PropTypes.shape({
  glAccount: PropTypes.string.isRequired,
});

export const GlAccountsPropTypes = PropTypes.arrayOf(GlAccountPropTypes);

export const SlTaxEntryPropTypes = PropTypes.shape({
  type: PropTypes.string.isRequired,
  activity: PropTypes.string.isRequired,
});

export const SlTaxEntriesPropTypes = PropTypes.arrayOf(SlTaxEntryPropTypes);
